import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import {MatTableDataSource} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import { AppSettings } from '../../app.constant';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { Student } from 'src/app/shared/interface/student';

import { Program } from 'src/app/shared/class/program';
import { Module } from 'src/app/shared/class/module';
import { Observable } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { StudentsService } from 'src/app/shared/services/students.service';

export interface State {
  flag: string;
  name: string;
  population: string;
}

@Component({
  selector: 'examination',
  templateUrl: './examination.component.html',
  styleUrls: ['./examination.component.css']
})
export class ExaminationComponent implements OnInit {
  options:any;

  studentCtrl = new FormControl();
  filteredStudent: Observable<Student[]>;
  subjectForm:FormGroup; 
  programs:any;
  errorMessage:any;
  module:any;

  modules:any;
  students:Student[]=[
    {
      BatchCode:'C0001',
      BatchName:'BOHS',
      EnrolmentNo:'P0001',
      PK_StudentID :'1',
      FirstName: 'Arkansas',
      LastName: '2.978M',
      DateOfBirth:'',
      Gender:'',
      EmailID: 'shintoonline@gmail.com',
    },
    {
      BatchCode:'C0001',
      BatchName:'MOHS',
      EnrolmentNo:'P0001',
      PK_StudentID :'1',
      FirstName: 'Arkansas',
      LastName: '2.978M',
      DateOfBirth:'',
      Gender:'',
      EmailID: 'shintoonline@gmail.com',
    },
    {
      BatchCode:'C0001',
      BatchName:'BOHS',
      EnrolmentNo:'P0001',
      PK_StudentID :'1',
      FirstName: 'Arkansas',
      LastName: '2.978M',
      DateOfBirth:'',
      Gender:'',
      EmailID: 'shintoonline@gmail.com',
    },
    {
      BatchCode:'C0001',
      BatchName:'BOHS',
      EnrolmentNo:'P0001',
      PK_StudentID :'1',
      FirstName: 'Arkansas',
      LastName: '2.978M',
      
      DateOfBirth:'',
      Gender:'',
      EmailID: 'shintoonline@gmail.com',
    },
    
  ];
  selectedProgram:Program = new Program (1,'ABC','asd','sadasdsa');
  constructor(private formbuilder:FormBuilder,
    private _programservice:ProgramService,
    private _moduleservice:ModuleService,
    private _studentservuce:StudentsService) {

      this.filteredStudent = this.studentCtrl.valueChanges
      .pipe(
        startWith(''),
        map(student => student ? this._filterStudents(student) : this.students.slice())
      );
    
     }

  ngOnInit() {
      this.subjectForm = this.formbuilder.group({
      'FK_ProgramID':[''],
      'FK_ModuleID':[''],
     'SubjectEntities' : this.formbuilder.array([])
    })
    this.getModuleByProgramID(this.selectedProgram.PK_ProgramID);
    this.getAllProgram();
    this.getAllStudents();
  }



  private _filterStudents(value: string): Student[] {
    const filterValue = value.toLowerCase();
    return this.students.filter(student => student.FirstName.toLowerCase().indexOf(filterValue) === 0);

  }

  get SUBJECTForm() {
    return this.subjectForm.get('SubjectEntities') as FormArray
  }

  addSubject(){
    const SUBJECTfb = this.formbuilder.group({
      PK_SubjectID : [],
      SubjectName : [],
      SubjectCode:[]
    })
    this.SUBJECTForm.push(SUBJECTfb);
  }

  deleteSubject(i){
    alert(i);
        this.SUBJECTForm.removeAt(i)
  }


  getAllStudents() :void  {
    this._studentservuce.getAllStudents(AppSettings.API_ENDPOINT+AppSettings.GetAllStudents).subscribe(
   data =>
      {
      //  this.students=data;
        console.log(this.students);
   },
   error => this.errorMessage = <any>error)
 }

  getAllProgram() :void  {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT+AppSettings.GetAllProgram).subscribe(
   data =>
      {
        this.programs=data;
   },
   error => this.errorMessage = <any>error)
 }

getModuleByProgramID(PK_ProgramID) :void  {
 this._moduleservice.getAllModule(AppSettings.API_ENDPOINT+AppSettings.GetAllModule).subscribe(
 data =>
   {
     this.module=data;
     this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
},
error => this.errorMessage = <any>error)
 }

}
